export const ApiURL = () => {
  // New central api domain name destination:
  // API_URL: "https://api2.crmit.co.uk/ci-4-jwt/public",

  // get curent domain name
  const domainName = window.location.hostname;

  let API_URL;

  switch (true) {
    case domainName.includes("local"):
      API_URL = { API_URL: "https://api2.crmit.co.uk/ci-4-jwt/public" };
      break;
    case domainName.includes("dev02"):
      API_URL = { API_URL: "https://dev02-api.crmit.app/public" };
      break;
    case domainName.includes("dev"):
      API_URL = { API_URL: "https://api2.crmit.co.uk/ci-4-jwt/public" };
      break;
    case domainName.includes("qa01"):
      API_URL = { API_URL: "https://qa01-api.crmit.app/public" };
      break;
    case domainName.includes("qa"):
      API_URL = { API_URL: "https://seashell-app-fliwf.ondigitalocean.app" };
      break;
    case domainName.includes("portal"):
      API_URL = { API_URL: "https://api.crmit.app/public" };
      break;
    case domainName.includes("v2"):
      API_URL = { API_URL: "https://api.crmit.co.uk/public" };
      break;
    case domainName.includes("prod"):
      API_URL = {
        API_URL: "https://api.crmit.app/public",
      };
      break;
    default:
        API_URL = { API_URL: "https://api2.crmit.co.uk/ci-4-jwt/public" };
      break;
  }

  return API_URL;
};
